







import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { ISprint, IProjectMin } from '@/lib/interfaces';
import { getSprintInProject } from '@/services/api.service';

@Component
export default class SprintRow extends Vue {
  @Prop() private sprint!: ISprint;
  // Если нет sprint, то сами делаем запрос
  @Prop() private sprintId!: string;
  @Prop() private project!: IProjectMin;

  private responseSprint: ISprint | null = null;

  private async mounted() {
    if (this.sprintId) {
      this.responseSprint = await getSprintInProject(this.project._id!, this.sprintId);
    }
  }

  private get finalSprint(): ISprint {
    return this.sprint || this.responseSprint;
  }
}
